import {Link as RouterLink} from "react-router-dom";
import {Box, Link} from "@chakra-ui/react";
import {MdPermContactCalendar} from "@onemind-services-llc/react-icons-ng/md";

const Navigation = (props) => {
  const {
    planType,
    selectedPlan = {},
    selectedFrequency = {},
    selectedOS = {},
    onClose,
  } = props;
  return (
    <Box
      minH={"40px"}
      color={"#16191f"}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"space-between"}
      fontSize={"14px"}
      padding={{
        base: "0.25rem 1rem 1rem 1rem",
        lg: "1rem",
      }}
      gap={2}
      flexWrap={"wrap"}
    >
      <Link as={RouterLink} to="/request" data-cy="view-summary-button">
        <button
          style={{
            padding: "6px 15px",
            color: "#545b64",
            border: "1px solid #545b64",
            fontWeight: "700",
          }}
          onClick={() => {
            onClose();
          }}
          onMouseEnter={(e) => (e.target.style.background = "#fafafa")}
          onMouseLeave={(e) => (e.target.style.background = "#ffffff")}
        >
          Save and view summary
        </button>
      </Link>
      {planType !== "Custom" ? (
        <Link
          href={`https://dashboard.cloudmylab.com/app/add-product/${planType}?os=${selectedOS.id}&plan=${selectedPlan.id}&frequency=${selectedFrequency.value}`}
        >
          <button
            style={{
              padding: "6px 20px",
              color: "white",
              background: "#1A5F7A",
              border: "1px solid #1A5F7A",
              fontWeight: "700",
            }}
          >
            <i className="fas fa-server" />
            &nbsp; Buy Package
          </button>
        </Link>
      ) : (
        <Link href="https://cloudmylab.com/contact-us">
          <button
            style={{
              padding: "6px 20px",
              color: "white",
              background: "#1A5F7A",
              border: "1px solid #1A5F7A",
              fontWeight: "700",
              display: "flex",
              alignItems: "center",
            }}
          >
            <MdPermContactCalendar />
            &nbsp; Contact Us
          </button>
        </Link>
      )}
    </Box>
  );
};

export default Navigation;
